import { Routes } from "@angular/router";
import { AdminHeaderComponent } from "@components/admin-header/admin-header";
import { AllocationGridDetailsComponent } from "@components/allocationGridDetails/allocationGridDetails";
import { CadViewerComponent } from "@components/cadViewer/cadViewer";
import { DeliveryNoteLineItemGridDetailsComponent } from "@components/deliveryNoteLineItemGridDetails/deliveryNoteLineItemGridDetails";
import { EdiMessageGridDetailsComponent } from "@components/ediMessageGridDetails/ediMessageGridDetails";
import { EdiOrderDayQuantitiesComponent } from "@components/ediOrderDayQuantities/ediOrderDayQuantities";
import { EdiSummaryFixingsDetailsComponent } from "@components/ediSummaryFixingsGridDetails/ediSummaryFixingsGridDetails";
import { FooterComponent } from "@components/footer/footer";
import { HeaderComponent } from "@components/header/header";
import { HeatMapComponent } from "@components/heatMap/heatMap";
import { InvoiceGridDetailsComponent } from "@components/invoiceGridDetails/invoiceGridDetails";
import { ModalComponent } from "@components/modal/modal";
import { PurchaseGridDetailsComponent } from "@components/purchaseGridDetails/purchaseGridDetails";
import { SalesEnquiryGridDetailsComponent } from "@components/salesEnquiryGridDetails/salesEnquiryGridDetails";
import { SalesOrderGridDetailsComponent } from "@components/salesOrderGridDetails/salesOrderGridDetails";
import { SkeletonComponent } from "@components/skeleton/skeleton";
import { ToolroomLoaderComponent } from "@components/toolroomLoader/toolroomLoader";
import { WorkForceWorkOrderStagesDetailsComponent } from "@components/workForceWorkOrderStagesDetails/workForceWorkOrderStagesDetails";
import { environment } from "@environments/environment";
import { AccidentIdAdminComponent } from "@pages/adminRoute/accidents-id/accidents-id";
import { AccidentAdminComponent } from "@pages/adminRoute/accidents/accidents";
import { AdminRouteComponent } from "@pages/adminRoute/adminRoute";
import { AllocationsIdAdminComponent } from "@pages/adminRoute/allocations-id/allocations-id";
import { AllocationsAdminComponent } from "@pages/adminRoute/allocations/allocations";
import { AssetsIdAdminComponent } from "@pages/adminRoute/assets-id/assets-id";
import { AssetsAdminComponent } from "@pages/adminRoute/assets/assets";
import { AssetTypesIdAdminComponent } from "@pages/adminRoute/assetTypes-id/assetTypes-id";
import { AssetTypesAdminComponent } from "@pages/adminRoute/assetTypes/assetTypes";
import { AuditIdAdminComponent } from "@pages/adminRoute/audits-id/audits-id";
import { AuditAdminComponent } from "@pages/adminRoute/audits/audits";
import { BankDetailsIdAdminComponent } from "@pages/adminRoute/bankDetails-id/bankDetails-id";
import { BankDetailsAdminComponent } from "@pages/adminRoute/bankDetails/bankDetails";
import { BilletPlannerAdminComponent } from "@pages/adminRoute/billetPlanner/billetPlanner";
import { BlockBoardAdminComponent } from "@pages/adminRoute/blockBoard/blockBoard";
import { CadViewerPageAdminComponent } from "@pages/adminRoute/cadViewer/cadViewer";
import { ClientIdAdminComponent } from "@pages/adminRoute/clients-id/clients-id";
import { ClientAdminComponent } from "@pages/adminRoute/clients/clients";
import { ClockingAdminComponent } from "@pages/adminRoute/clocking/clocking";
import { CompanyHolidaysIdAdminComponent } from "@pages/adminRoute/companyHolidays-id/companyHolidays-id";
import { CompanyHolidaysAdminComponent } from "@pages/adminRoute/companyHolidays/companyHolidays";
import { CompleteAccountIdAdminComponent } from "@pages/adminRoute/complete-account-id/complete-account-id";
import { ContractsIdAdminComponent } from "@pages/adminRoute/contracts-id/contracts-id";
import { ContractsAdminComponent } from "@pages/adminRoute/contracts/contracts";
import { CrmDashboardAdminComponent } from "@pages/adminRoute/crm/crm";
import { CrmContactIdAdminComponent } from "@pages/adminRoute/crmContacts-id/crmContacts-id";
import { CrmContactsAdminComponent } from "@pages/adminRoute/crmContacts/crmContacts";
import { CrmEventIdAdminComponent } from "@pages/adminRoute/crmEvents-id/crmEvents-id";
import { CrmEventsAdminComponent } from "@pages/adminRoute/crmEvents/crmEvents";
import { CrmInteractionIdAdminComponent } from "@pages/adminRoute/crmInteractions-id/crmInteractions-id";
import { CrmInteractionsAdminComponent } from "@pages/adminRoute/crmInteractions/crmInteractions";
import { CrmLeadIdAdminComponent } from "@pages/adminRoute/crmLeads-id/crmLeads-id";
import { CrmLeadsAdminComponent } from "@pages/adminRoute/crmLeads/crmLeads";
import { CrmOpportunityIdAdminComponent } from "@pages/adminRoute/crmOpportunities-id/crmOpportunities-id";
import { CrmOpportunitiesAdminComponent } from "@pages/adminRoute/crmOpportunities/crmOpportunities";
import { CrmOpportunityPipelineAdminComponent } from "@pages/adminRoute/crmOpportunityPipeline/crmOpportunityPipeline";
import { CuttingToolsIdAdminComponent } from "@pages/adminRoute/cuttingTools-id/cuttingTools-id";
import { CuttingToolsAdminComponent } from "@pages/adminRoute/cuttingTools/cuttingTools";
import { DashboardAdminComponent } from "@pages/adminRoute/dashboard/dashboard";
import { DeliveryNotesDeletedAdminComponent } from "@pages/adminRoute/deliveryNotes-deleted/deliveryNotes-deleted";
import { DeliveryNotesIdAdminComponent } from "@pages/adminRoute/deliveryNotes-id/deliveryNotes-id";
import { DeliveryNotesAdminComponent } from "@pages/adminRoute/deliveryNotes/deliveryNotes";
import { EdiForecastsAdminComponent } from "@pages/adminRoute/edi/ediForecasts/ediForecasts";
import { EdiMessagesIdAdminComponent } from "@pages/adminRoute/edi/ediMessages-id/ediMessages-id";
import { EdiMessagesAdminComponent } from "@pages/adminRoute/edi/ediMessages/ediMessages";
import { EdiOrdersAdminComponent } from "@pages/adminRoute/edi/ediOrders/ediOrders";
import { EdiShippingNotesIdAdminComponent } from "@pages/adminRoute/edi/ediShippingNotes-id/ediShippingNotes-id";
import { EdiShippingNotesAdminComponent } from "@pages/adminRoute/edi/ediShippingNotes/ediShippingNotes";
import { EdiSummaryAdminComponent } from "@pages/adminRoute/edi/ediSummary/ediSummary";
import { EdiSpotOrdersReportAdminComponent } from "@pages/adminRoute/edi/spotOrders/spotOrders";
import { EmailsIdAdminComponent } from "@pages/adminRoute/emails-id/emails-id";
import { EmailsAdminComponent } from "@pages/adminRoute/emails/emails";
import { EmailTemplateIdAdminComponent } from "@pages/adminRoute/emailTemplates-id/emailTemplates-id";
import { EmailTemplateAdminComponent } from "@pages/adminRoute/emailTemplates/emailTemplates";
import { EmployeeMachineTimeAdminComponent } from "@pages/adminRoute/employeeMachineTime/employeeMachineTime";
import { ExportLogsAdminComponent } from "@pages/adminRoute/exportLogs/exportLogs";
import { ExternalPackagingIdAdminComponent } from "@pages/adminRoute/externalPackaging-id/externalPackaging-id";
import { ExternalPackagingAdminComponent } from "@pages/adminRoute/externalPackaging/externalPackaging";
import { FeatureAdminComponent } from "@pages/adminRoute/features/features";
import { FirewallLogFailureReasonsIdAdminComponent } from "@pages/adminRoute/firewallLogFailureReasons-id/firewallLogFailureReasons-id";
import { FirewallLogFailureReasonsAdminComponent } from "@pages/adminRoute/firewallLogFailureReasons/firewallLogFailureReasons";
import { FirewallLogsIdAdminComponent } from "@pages/adminRoute/firewallLogs-id/firewallLogs-id";
import { FirewallLogsAdminComponent } from "@pages/adminRoute/firewallLogs/firewallLogs";
import { FloorplanComponent } from "@pages/adminRoute/floorplan/floorplan";
import { ForgotPasswordAdminComponent } from "@pages/adminRoute/forgotPassword/forgotPassword";
import { GroupsIdAdminComponent } from "@pages/adminRoute/groups-id/groups-id";
import { GroupsAdminComponent } from "@pages/adminRoute/groups/groups";
import { HelpIdAdminComponent } from "@pages/adminRoute/help-id/help-id";
import { HelpAdminComponent } from "@pages/adminRoute/help/help";
import { HolidayAllowancesIdAdminComponent } from "@pages/adminRoute/holidayAllowances-id/holidayAllowances-id";
import { HolidayAllowancesAdminComponent } from "@pages/adminRoute/holidayAllowances/holidayAllowances";
import { HolidayRequestsIdAdminComponent } from "@pages/adminRoute/holidayRequests-id/holidayRequests-id";
import { HolidayRequestsPlannerAdminComponent } from "@pages/adminRoute/holidayRequests-planner/holidayRequests-planner";
import { HolidayRequestsAdminComponent } from "@pages/adminRoute/holidayRequests/holidayRequests";
import { HolidaySettingsAdminComponent } from "@pages/adminRoute/holidaySettings/holidaySettings";
import { InterfaceDevicesIdAdminComponent } from "@pages/adminRoute/interfaceDevices-id/interfaceDevices-id";
import { InterfaceDevicesAdminComponent } from "@pages/adminRoute/interfaceDevices/interfaceDevices";
import { InvoicesArchiveAdminComponent } from "@pages/adminRoute/invoices-archive/invoices-archive";
import { InvoicesDeletedAdminComponent } from "@pages/adminRoute/invoices-deleted/invoices-deleted";
import { InvoicesIdAdminComponent } from "@pages/adminRoute/invoices-id/invoices-id";
import { InvoicesAdminComponent } from "@pages/adminRoute/invoices/invoices";
import { KnowledgeBaseIdAdminComponent } from "@pages/adminRoute/knowledgeBase-id/knowledgeBase-id";
import { KnowledgeBaseAdminComponent } from "@pages/adminRoute/knowledgeBase/knowledgeBase";
import { LinkedPartGroupsIdAdminComponent } from "@pages/adminRoute/linkedPartGroups-id/linkedPartGroups-id";
import { LinkedPartGroupsAdminComponent } from "@pages/adminRoute/linkedPartGroups/linkedPartGroups";
import { LogIdAdminComponent } from "@pages/adminRoute/logs-id/logs-id";
import { LogAdminComponent } from "@pages/adminRoute/logs/logs";
import { MachineQuestionnairesAdminComponent } from "@pages/adminRoute/machineQuestionnaires/machineQuestionnaires";
import { MachineRequestsAdminComponent } from "@pages/adminRoute/machineRequests/machineRequests";
import { MachinesIdPFMEAsAdminComponent } from "@pages/adminRoute/machines-id-pfmeas/machines-id-pfmeas";
import { MachinesIdAdminComponent } from "@pages/adminRoute/machines-id/machines-id";
import { MachinesAdminComponent } from "@pages/adminRoute/machines/machines";
import { MaintenanceSchedulesIdAdminComponent } from "@pages/adminRoute/maintenanceSchedules-id/maintenanceSchedules-id";
import { MaintenanceSchedulesAdminComponent } from "@pages/adminRoute/maintenanceSchedules/maintenanceSchedules";
import { MenuAdminComponent } from "@pages/adminRoute/menu/menu";
import { NonConformanceReportsIdAdminComponent } from "@pages/adminRoute/nonConformanceReports-id/nonConformanceReports-id";
import { NonConformanceReportsAdminComponent } from "@pages/adminRoute/nonConformanceReports/nonConformanceReports";
import { OpFloorplanComponent } from "@pages/adminRoute/opfloorplan/opfloorplan";
import { OpsPlanningDepartmentsIdAdminComponent } from "@pages/adminRoute/opsPlanning/departments-id/departments-id";
import { OpsPlanningFirewallAdminComponent } from "@pages/adminRoute/opsPlanning/firewall/firewall";
import { OpsPlanningManForManAdminComponent } from "@pages/adminRoute/opsPlanning/man-for-man/man-for-man";
import { OpsPlanningOutsideProcessContractMovementAdminComponent } from "@pages/adminRoute/opsPlanning/outsideProcessContractMovements/outsideProcessContractMovements";
import { OpsPlanningSitesIdAdminComponent } from "@pages/adminRoute/opsPlanning/sites-id/sites-id";
import { OpsPlanningWorkforceAdminComponent } from "@pages/adminRoute/opsPlanning/workforce/workforce";
import { OrgChartAdminComponent } from "@pages/adminRoute/orgChart/orgChart";
import { OutsideProcessContractsIdAdminComponent } from "@pages/adminRoute/outsideProcessContracts-id/outsideProcessContracts-id";
import { OutsideProcessContractsAdminComponent } from "@pages/adminRoute/outsideProcessContracts/outsideProcessContracts";
import { OutstandingOrdersAdminComponent } from "@pages/adminRoute/outstandingOrders/outstandingOrders";
import { PackagingIdAdminComponent } from "@pages/adminRoute/packaging-id/packaging-id";
import { PackagingAdminComponent } from "@pages/adminRoute/packaging/packaging";
import { PartsDeletedAdminComponent } from "@pages/adminRoute/parts-deleted/parts-deleted";
import { PartsIdAdminComponent } from "@pages/adminRoute/parts-id/parts-id";
import { PartsAdminComponent } from "@pages/adminRoute/parts/parts";
import { PaymentTermsIdAdminComponent } from "@pages/adminRoute/paymentTerms-id/paymentTerms-id";
import { PaymentTermsAdminComponent } from "@pages/adminRoute/paymentTerms/paymentTerms";
import { PFMEASIdAdminComponent } from "@pages/adminRoute/pfmeas-id/pfmeas-id";
import { ProcessesIdAdminComponent } from "@pages/adminRoute/processes-id/processes-id";
import { ProcessesAdminComponent } from "@pages/adminRoute/processes/processes";
import { ProductionRequestsAdminComponent } from "@pages/adminRoute/productionRequests/productionRequests";
import { ProductionToolProgramsIdAdminComponent } from "@pages/adminRoute/productionToolPrograms-id/productionToolPrograms-id";
import { ProductionToolProgramsPrintAdminComponent } from "@pages/adminRoute/productionToolPrograms-print/productionToolPrograms-print";
import { ProductionToolsIdAdminComponent } from "@pages/adminRoute/productionTools-id/productionTools-id";
import { ProductionToolsAdminComponent } from "@pages/adminRoute/productionTools/productionTools";
import { ProjectIdAdminComponent } from "@pages/adminRoute/projects-id/projects-id";
import { ProjectAdminComponent } from "@pages/adminRoute/projects/projects";
import { PromisesBoardAdminComponent } from "@pages/adminRoute/promises-board/promises-board";
import { PromisesIdAdminComponent } from "@pages/adminRoute/promises-id/promises-id";
import { PromisesAdminComponent } from "@pages/adminRoute/promises/promises";
import { ProtectedGridsIdAdminComponent } from "@pages/adminRoute/protectedGrids-id/protectedGrids-id";
import { ProtectedGridsAdminComponent } from "@pages/adminRoute/protectedGrids/protectedGrids";
import { PurchasableItemsIdAdminComponent } from "@pages/adminRoute/purchasableItems-id/purchasableItems-id";
import { PurchasableItemsAdminComponent } from "@pages/adminRoute/purchasableItems/purchasableItems";
import { PurchaseLogsIdAdminComponent } from "@pages/adminRoute/purchaseLogs-id/purchaseLogs-id";
import { PurchaseLogsAdminComponent } from "@pages/adminRoute/purchaseLogs/purchaseLogs";
import { QmsDocumentsIdAdminComponent } from "@pages/adminRoute/qmsDocuments-id/qmsDocuments-id";
import { QmsDocumentsAdminComponent } from "@pages/adminRoute/qmsDocuments/qmsDocuments";
import { QuarantinedPartsAdminComponent } from "@pages/adminRoute/quarantinedParts/quarantinedParts";
import { QuotationAnalysisFormsIdAdminComponent } from "@pages/adminRoute/quotationAnalysisForms-id/quotationAnalysisForms-id";
import { QuotationAnalysisFormsAdminComponent } from "@pages/adminRoute/quotationAnalysisForms/quotationAnalysisForms";
import { EDIShippingNotesByPartReportAdminComponent } from "@pages/adminRoute/reports/ediShippingNotesByPart/ediShippingNotesByPart";
import { OutsideProcessContractsSentButNotReceivedReportAdminComponent } from "@pages/adminRoute/reports/outsideProcessContractsSentButNotReceived/outsideProcessContractsSentButNotReceived";
import { ScheduledReportsIdAdminComponent } from "@pages/adminRoute/reports/scheduledReports-id/scheduledReports-id";
import { ScheduledReportsAdminComponent } from "@pages/adminRoute/reports/scheduledReports/scheduledReports";
import { RequestForQuotesIdAdminComponent } from "@pages/adminRoute/requestForQuotes-id/requestForQuotes-id";
import { RequestForQuotesAdminComponent } from "@pages/adminRoute/requestForQuotes/requestForQuotes";
import { ResetPasswordAdminComponent } from "@pages/adminRoute/resetPassword/resetPassword";
import { SalesEnquiriesFeasibilityAdminComponent } from "@pages/adminRoute/salesEnquiries-feasibility/salesEnquiries-feasibility";
import { SalesEnquiriesIdAdminComponent } from "@pages/adminRoute/salesEnquiries-id/salesEnquiries-id";
import { SalesEnquiriesAdminComponent } from "@pages/adminRoute/salesEnquiries/salesEnquiries";
import { SalesOrdersPartsIdCreateWorkOrdersAdminComponent } from "@pages/adminRoute/salesOrderParts-id-createWorkOrders/salesOrderParts-id-createWorkOrders";
import { SalesOrdersIdDeliveryNotesAdminComponent } from "@pages/adminRoute/salesOrders-id-deliveryNotes/salesOrders-id-deliveryNotes";
import { SalesOrdersIdInvoicesAdminComponent } from "@pages/adminRoute/salesOrders-id-invoices/salesOrders-id-invoices";
import { SalesOrdersIdRFQsAdminComponent } from "@pages/adminRoute/salesOrders-id-rfqs/salesOrders-id-rfqs";
import { SalesOrdersIdAdminComponent } from "@pages/adminRoute/salesOrders-id/salesOrders-id";
import { SalesOrdersAdminComponent } from "@pages/adminRoute/salesOrders/salesOrders";
import { SitesIdAdminComponent } from "@pages/adminRoute/sites-id/sites-id";
import { SitesAdminComponent } from "@pages/adminRoute/sites/sites";
import { SkillsIdAdminComponent } from "@pages/adminRoute/skills-id/skills-id";
import { SkillsAdminComponent } from "@pages/adminRoute/skills/skills";
import { SmsAdminComponent } from "@pages/adminRoute/sms/sms";
import { SmsTemplateIdAdminComponent } from "@pages/adminRoute/smsTemplates-id/smsTemplates-id";
import { SmsTemplateAdminComponent } from "@pages/adminRoute/smsTemplates/smsTemplates";
import { StockStoreWorkOrderAllocationsAdminComponent } from "@pages/adminRoute/stockStoreWorkOrderAllocations/stockStoreWorkOrderAllocations";
import { StoreMapAdminComponent } from "@pages/adminRoute/storeMap/storeMap";
import { StoresIdAdminComponent } from "@pages/adminRoute/stores-id/stores-id";
import { StoresAdminComponent } from "@pages/adminRoute/stores/stores";
import { StockStoresHistoryAdminComponent } from "@pages/adminRoute/storesHistory/storesHistory";
import { SupervisorPerformanceAdminComponent } from "@pages/adminRoute/supervisorPerformance/supervisorPerformance";
import { SupervisorRequestReasonsIdAdminComponent } from "@pages/adminRoute/supervisorRequestReasons-id/supervisorRequestReasons-id";
import { SupervisorRequestReasonsAdminComponent } from "@pages/adminRoute/supervisorRequestReasons/supervisorRequestReasons";
import { SupervisorRequestsAdminComponent } from "@pages/adminRoute/supervisorRequests/supervisorRequests";
import { SupplierIdAdminComponent } from "@pages/adminRoute/suppliers-id/suppliers-id";
import { SupplierAdminComponent } from "@pages/adminRoute/suppliers/suppliers";
import { SystemParamIdValueAdminComponent } from "@pages/adminRoute/system-param-id-values-vid/system-param-id-values-vid";
import { SystemParamIdAdminComponent } from "@pages/adminRoute/system-param-id/system-param-id";
import { SystemParamsAdminComponent } from "@pages/adminRoute/system-params/system-params";
import { ToolHoldersIdAdminComponent } from "@pages/adminRoute/toolHolders-id/toolHolders-id";
import { ToolHoldersAdminComponent } from "@pages/adminRoute/toolHolders/toolHolders";
import { ToolingTypesIdAdminComponent } from "@pages/adminRoute/toolingTypes-id/toolingTypes-id";
import { ToolingTypesAdminComponent } from "@pages/adminRoute/toolingTypes/toolingTypes";
import { ToolOrderPlanningAdminComponent } from "@pages/adminRoute/toolOrderPlanning/toolOrderPlanning";
import { ToolOrdersIdAdminComponent } from "@pages/adminRoute/toolOrders-id/toolOrders-id";
import { ToolOrdersAdminComponent } from "@pages/adminRoute/toolOrders/toolOrders";
import { ToolroomProcessesIdAdminComponent } from "@pages/adminRoute/toolroomProcesses-id/toolroomProcesses-id";
import { ToolroomProcessesAdminComponent } from "@pages/adminRoute/toolroomProcesses/toolroomProcesses";
import { UserHolidaysAdminComponent } from "@pages/adminRoute/userHolidays/userHolidays";
import { UserProfilesIdAdminComponent } from "@pages/adminRoute/userProfiles-id/userProfiles-id";
import { UserProfilesAdminComponent } from "@pages/adminRoute/userProfiles/userProfiles";
import { UserSettingsAdminComponent } from "@pages/adminRoute/userSettings/userSettings";
import { VisitorsIdAdminComponent } from "@pages/adminRoute/visitors-id/visitors-id";
import { VisitorsAdminComponent } from "@pages/adminRoute/visitors/visitors";
import { AndonComponent } from "@pages/adminRoute/webapp/andon/andon";
import { DepartmentMachineOverviewComponent } from "@pages/adminRoute/webapp/departmentMachineOverview/departmentMachineOverview";
import { EmployeeOverviewComponent } from "@pages/adminRoute/webapp/employeeOverview/employeeOverview";
import { FirewallComponent } from "@pages/adminRoute/webapp/firewall/firewall";
import { FirewallMachineOverviewComponent } from "@pages/adminRoute/webapp/firewallMachineOverview/firewallMachineOverview";
import { GoodsDetailComponent } from "@pages/adminRoute/webapp/goods/goodsDetail/goodsDetail";
import { GoodsMenuComponent } from "@pages/adminRoute/webapp/goods/goodsMenu/goodsMenu";
import { OutsideProcessComponent } from "@pages/adminRoute/webapp/goods/outsideProcess/outsideProcess";
import { PurchaseDetailComponent } from "@pages/adminRoute/webapp/goods/purchaseDetail/purchaseDetail";
import { MachineOverviewComponent } from "@pages/adminRoute/webapp/machineOverview/machineOverview";
import { MoveStockComponent } from "@pages/adminRoute/webapp/moveStock/moveStock";
import { OperatorComponent } from "@pages/adminRoute/webapp/operator/operator";
import { PiSiteOverviewComponent } from "@pages/adminRoute/webapp/pi/siteOverview/piSiteOverview";
import { SiteOverviewComponent } from "@pages/adminRoute/webapp/siteOverview/siteOverview";
import { StockControlComponent } from "@pages/adminRoute/webapp/stockControl/stockControl";
import { SupervisorComponent } from "@pages/adminRoute/webapp/supervisor/supervisor";
import { ToolroomOverviewComponent } from "@pages/adminRoute/webapp/toolroomOverview/toolroomOverview";
import { WorkOrderScanComponent } from "@pages/adminRoute/webapp/workOrderScan/workOrderScan";
import { WorkOrderViewComponent } from "@pages/adminRoute/webapp/workOrderView/workOrderView";
import { WorkOrdersIdAdminComponent } from "@pages/adminRoute/workOrders-id/workOrders-id";
import { WorkOrdersAdminComponent } from "@pages/adminRoute/workOrders/workOrders";
import { HomeRouteComponent } from "@pages/homeRoute/homeRoute";
import { MainComponent } from "@pages/homeRoute/main/main";
import { PageNotFoundComponent } from "@pages/pageNotFound/pageNotFound";
import { PublicRouteComponent } from "@pages/publicRoute/publicRoute";
import { SupplierQuestionnairePublicComponent } from "@pages/publicRoute/supplierQuestionnaire/supplierQuestionnaire";
import { SupplierRequestForQuoteResponsePublicComponent } from "@pages/publicRoute/supplierRequestForQuoteResponse/supplierRequestForQuoteResponse";
import { ServiceNotAvailableComponent } from "@pages/serviceNotAvailable/serviceNotAvailable";

export const routes: Routes = [
	{ children: [
		{ component: DashboardAdminComponent, path: "" },
		{ children: [
			{ component: AccidentAdminComponent, path: "" },
			{ component: AccidentIdAdminComponent, path: ":id" },
		], path: "accidents" },
		{ children: [
			{ component: AllocationsAdminComponent, path: "" },
			{ component: AllocationsIdAdminComponent, path: ":id" },
		], path: "allocations" },
		{ component: AndonComponent, path: "andon/:id" },
		{ children: [
			{ component: AssetsAdminComponent, path: "" },
			{ component: AssetsIdAdminComponent, path: ":id" },
		], path: "assets" },
		{ children: [
			{ component: AssetTypesAdminComponent, path: "" },
			{ component: AssetTypesIdAdminComponent, path: ":id" },
		], path: "assetTypes" },
		{ children: [
			{ component: AuditAdminComponent, path: "" },
			{ component: AuditIdAdminComponent, path: ":id" },
		], path: "audits" },
		{ children: [
			{ component: BankDetailsAdminComponent, path: "" },
			{ component: BankDetailsIdAdminComponent, path: ":id" },
		], path: "bank-details" },
		{ children: [
			{ component: ClientAdminComponent, path: "" },
			{ component: ClientIdAdminComponent, path: ":id" },
		], path: "clients" },
		{ component: CadViewerPageAdminComponent, path: "cad-viewer" },
		{ component: CrmDashboardAdminComponent, path: "crm" },
		{ children: [
			{ component: CrmContactsAdminComponent, path: "" },
			{ component: CrmContactIdAdminComponent, path: ":id" },
		], path: "crmContacts" },
		{ children: [
			{ component: CrmEventsAdminComponent, path: "" },
			{ component: CrmEventIdAdminComponent, path: ":id" },
		], path: "crmEvents" },
		{ children: [
			{ component: CrmInteractionsAdminComponent, path: "" },
			{ component: CrmInteractionIdAdminComponent, path: ":id" },
		], path: "crmInteractions" },
		{ children: [
			{ component: CrmLeadsAdminComponent, path: "" },
			{ component: CrmLeadIdAdminComponent, path: ":id" },
		], path: "crmLeads" },
		{ children: [
			{ component: CrmOpportunitiesAdminComponent, path: "" },
			{ component: CrmOpportunityPipelineAdminComponent, path: "pipeline" },
			{ component: CrmOpportunityIdAdminComponent, path: ":id" },
		], path: "crmOpportunities" },
		{ component: ClockingAdminComponent, path: "clocking/:id" },
		{ children: [
			{ component: CompanyHolidaysAdminComponent, path: "" },
			{ component: CompanyHolidaysIdAdminComponent, path: ":id" },
		], path: "companyHolidays" },
		{ children: [
			{ component: ContractsAdminComponent, path: "" },
			{ component: ContractsIdAdminComponent, path: ":id" },
		], path: "contracts" },
		{ children: [
			{ component: CuttingToolsAdminComponent, path: "" },
			{ component: CuttingToolsIdAdminComponent, path: ":id" },
		], path: "cuttingTools" },
		{ component: CompleteAccountIdAdminComponent, path: "complete-account/:id" },
		{ children: [
			{ component: DeliveryNotesAdminComponent, path: "" },
			{ component: DeliveryNotesDeletedAdminComponent, path: "deleted" },
			{ component: DeliveryNotesIdAdminComponent, path: ":id" },
		], path: "deliveryNotes" },
		{ component: EdiForecastsAdminComponent, path: "edi-forecasts" },
		{ children: [
			{ component: EdiMessagesAdminComponent, path: "" },
			{ component: EdiMessagesIdAdminComponent, path: ":id" },
		], path: "edi-messages" },
		{ component: EdiOrdersAdminComponent, path: "edi-orders" },
		{ children: [
			{ component: EdiShippingNotesAdminComponent, path: "" },
			{ component: EdiShippingNotesIdAdminComponent, path: ":id" },
		], path: "edi-shipping-notes" },
		{ component: EdiSpotOrdersReportAdminComponent, path: "edi-spot-orders" },
		{ component: EdiSummaryAdminComponent, path: "edi-summary" },
		{ component: EmployeeMachineTimeAdminComponent, path: "employee-machine-time" },
		{ children: [
			{ component: EmailsAdminComponent, path: "" },
			{ component: EmailsIdAdminComponent, path: ":id" }
		], path: "emails" },
		{ children: [
			{ component: EmailTemplateAdminComponent, path: "" },
			{ component: EmailTemplateIdAdminComponent, path: ":id" },
		], path: "email-templates" },
		{ component: ExportLogsAdminComponent, path: "export-logs" },
		{ children: [
			{ component: ExternalPackagingAdminComponent, path: "" },
			{ component: ExternalPackagingIdAdminComponent, path: ":id" },
		], path: "externalPackaging" },
		{ component: FeatureAdminComponent, path: "features-hidden" },
		{ component: FirewallComponent, path: "webapps/firewall/:id" },
		{ children: [
			{ component: FirewallLogsAdminComponent, path: "" },
			{ component: FirewallLogsIdAdminComponent, path: ":id" },
		], path: "firewallLogs" },
		{ children: [
			{ component: FirewallLogFailureReasonsAdminComponent, path: "" },
			{ component: FirewallLogFailureReasonsIdAdminComponent, path: ":id" },
		], path: "firewallLogFailureReasons" },
		{ component: FloorplanComponent, path: "floorplan" },
		{ component: ForgotPasswordAdminComponent, path: "forgotPassword" },
		{ component: GoodsDetailComponent, path: "webapps/goodsDetail/:id/:mode" },
		{ component: GoodsMenuComponent, path: "webapps/goods/:id/:mode" },
		{ children: [
			{ component: GroupsAdminComponent, path: "" },
			{ component: GroupsIdAdminComponent, path: ":id" },
		], path: "groups" },
		{ children: [
			{ component: HelpAdminComponent, path: "" },
			{ component: HelpIdAdminComponent, path: ":id" },
		], path: "help" },
		{ children: [
			{ component: HolidayAllowancesAdminComponent, path: "" },
			{ component: HolidayAllowancesIdAdminComponent, path: ":id" },
		], path: "holidayAllowances" },
		{ children: [
			{ component: HolidayRequestsAdminComponent, path: "" },
			{ component: HolidayRequestsIdAdminComponent, path: ":id" },
		], path: "holidayRequests" },
		{ component: HolidayRequestsPlannerAdminComponent, path: "holidayRequestsPlanner" },
		{ component: HolidaySettingsAdminComponent, path: "holidaySettings" },
		{ children: [
			{ component: InterfaceDevicesAdminComponent, path: "" },
			{ component: InterfaceDevicesIdAdminComponent, path: ":id" },
		], path: "interfaceDevices" },
		{ children: [
			{ component: InvoicesAdminComponent, path: "" },
			{ component: InvoicesArchiveAdminComponent, path: "archive" },
			{ component: InvoicesDeletedAdminComponent, path: "deleted" },
			{ component: InvoicesIdAdminComponent, path: ":id" },
		], path: "invoices" },
		{ children: [
			{ component: KnowledgeBaseAdminComponent, path: "" },
			{ component: KnowledgeBaseIdAdminComponent, path: ":id" },
		], path: "knowledgeBase" },
		{ children: [
			{ component: LinkedPartGroupsAdminComponent, path: "" },
			{ component: LinkedPartGroupsIdAdminComponent, path: ":id" },
		], path: "linkedPartGroups" },
		{ children: [
			{ component: LogAdminComponent, path: "" },
			{ component: LogIdAdminComponent, path: ":id" },
		], path: "logs" },
		{ component: EmployeeOverviewComponent, path: "webapps/employeeOverview/:id" },
		{ component: DepartmentMachineOverviewComponent, path: "webapps/departmentMachineOverview/:site/:department" },
		{ component: FirewallMachineOverviewComponent, path: "webapps/firewallMachineOverview/:site/:department" },
		{ component: MachineOverviewComponent, path: "machineOverview/:id" },
		{ component: SiteOverviewComponent, path: "webapps/siteOverview/:id" },
		{ component: PiSiteOverviewComponent, path: "webapps/pi/siteOverview/:id" },
		{ children: [
			{ component: MachinesAdminComponent, path: "" },
			{ component: MachinesIdAdminComponent, path: ":id" },
			{ component: MachinesIdPFMEAsAdminComponent, path: ":id/pfmeas" },
		], path: "machines" },
		{ component: MachineQuestionnairesAdminComponent, path: "machineQuestionnaires" },
		{ component: MachineRequestsAdminComponent, path: "machineRequests" },
		{ children: [
			{ component: MaintenanceSchedulesAdminComponent, path: "" },
			{ component: MaintenanceSchedulesIdAdminComponent, path: ":id" },
		], path: "maintenanceSchedules" },
		{ component: MenuAdminComponent, path: "menu/:id" },
		{ component: MoveStockComponent, path: "webapps/moveStock" },
		{ component: OperatorComponent, path: "operator/:id" },
		{ component: ToolroomOverviewComponent, path: "toolroomOverview/:id" },
		{ component: OpFloorplanComponent, path: "opfloorplan" },
		{ children: [
			{ component: OutsideProcessContractsAdminComponent, path: "" },
			{ component: OutsideProcessContractsIdAdminComponent, path: ":id" },
		], path: "outsideProcessContracts" },
		{ children: [
			{ component: OpsPlanningDepartmentsIdAdminComponent, path: "department/:department" },
			{ component: OpsPlanningFirewallAdminComponent, path: "firewall" },
			{ component: OpsPlanningManForManAdminComponent, path: "operatorPlan" },
			{ component: OpsPlanningOutsideProcessContractMovementAdminComponent, path: "outsideProcessContractMovements" },
			{ component: OpsPlanningSitesIdAdminComponent, path: "site/:site" },
			{ component: OpsPlanningWorkforceAdminComponent, path: "workforce" },
		], path: "opsPlanning" },
		{ component: OrgChartAdminComponent, path: "orgchart" },
		{ component: OutsideProcessComponent, path: "webapps/outside/:id/:mode" },
		{ component: OutstandingOrdersAdminComponent, path: "outstandingOrders" },
		{ children: [
			{ component: NonConformanceReportsAdminComponent, path: "" },
			{ component: NonConformanceReportsIdAdminComponent, path: ":id" },
		], path: "nonConformanceReports" },
		{ children: [
			{ component: PackagingAdminComponent, path: "" },
			{ component: PackagingIdAdminComponent, path: ":id" },
		], path: "packaging" },
		{ children: [
			{ component: PartsAdminComponent, path: "" },
			{ component: PartsDeletedAdminComponent, path: "deleted" },
			{ component: PartsIdAdminComponent, path: ":id" },
		], path: "parts" },
		{ children: [
			{ component: PaymentTermsAdminComponent, path: "" },
			{ component: PaymentTermsIdAdminComponent, path: ":id" },
		], path: "paymentTerms" },
		{ component: PFMEASIdAdminComponent, path: "pfmeas/:machineId/:id" },
		{ children: [
			{ component: ProcessesAdminComponent, path: "" },
			{ component: ProcessesIdAdminComponent, path: ":id" },
		], path: "processes" },
		{ component: ProductionRequestsAdminComponent, path: "productionRequests" },
		{ children: [
			{ component: ProductionToolsAdminComponent, path: "" },
			{ component: ProductionToolsIdAdminComponent, path: ":id" },
		], path: "productionTools" },
		{ children: [
			{ component: ToolOrdersAdminComponent, path: "" },
			{ component: ToolOrdersIdAdminComponent, path: ":id" },
		], path: "toolOrders" },
		{ component: ToolOrderPlanningAdminComponent, path: "toolOrderPlanning" },
		{ component: BilletPlannerAdminComponent, path: "billetPlanner" },
		{ component: BlockBoardAdminComponent, path: "blockBoard" },
		{ component: SupervisorPerformanceAdminComponent, path: "supervisorPerformance" },
		{ children: [
			{ component: ProductionToolProgramsPrintAdminComponent, path: ":id/print" },
			{ component: ProductionToolProgramsIdAdminComponent, path: ":id" },
		], path: "productionToolPrograms" },
		{ children: [
			{ component: ProjectAdminComponent, path: "" },
			{ component: ProjectIdAdminComponent, path: ":id" },
		], path: "projects" },
		{ children: [
			{ component: PromisesAdminComponent, path: "" },
			{ component: PromisesBoardAdminComponent, path: "board" },
			{ component: PromisesIdAdminComponent, path: ":id" },
		], path: "promises" },
		{ children: [
			{ component: ProtectedGridsAdminComponent, path: "" },
			{ component: ProtectedGridsIdAdminComponent, path: ":id" },
		], path: "protectedGrids" },
		{ children: [
			{ component: PurchasableItemsAdminComponent, path: "" },
			{ component: PurchasableItemsIdAdminComponent, path: ":id" },
		], path: "purchasableItems" },
		{ component: PurchaseDetailComponent, path: "webapps/purchaseDetail/:id" },
		{ children: [
			{ component: PurchaseLogsAdminComponent, path: "" },
			{ component: PurchaseLogsIdAdminComponent, path: ":id" },
		], path: "purchaseLogs" },
		{ children: [
			{ component: QmsDocumentsAdminComponent, path: "" },
			{ component: QmsDocumentsIdAdminComponent, path: ":id" },
		], path: "qmsDocuments" },
		{ component: QuarantinedPartsAdminComponent, path: "quarantined-parts" },
		{ children: [
			{ component: QuotationAnalysisFormsAdminComponent, path: "" },
			{ component: QuotationAnalysisFormsIdAdminComponent, path: ":id" },
		], path: "quotationAnalysisForms" },
		{ children: [
			{ component: EDIShippingNotesByPartReportAdminComponent, path: "ediShippingNotesByPart" },
			{ component: OutsideProcessContractsSentButNotReceivedReportAdminComponent, path: "outsideProcessContractsSentButNotReceived" },
			{ children: [
				{ component: ScheduledReportsAdminComponent, path: "" },
				{ component: ScheduledReportsIdAdminComponent, path: ":id" }
			], path: "scheduledReports" },
		], path: "reports" },
		{ children: [
			{ component: RequestForQuotesAdminComponent, path: "" },
			{ component: RequestForQuotesIdAdminComponent, path: ":id" },
		], path: "requestForQuotes" },
		{ component: ResetPasswordAdminComponent, path: "resetPassword/:id" },
		{ children: [
			{ component: SalesEnquiriesAdminComponent, path: "" },
			{ component: SalesEnquiriesFeasibilityAdminComponent, path: "feasibility" },
			{ component: SalesEnquiriesIdAdminComponent, path: ":id" },
		], path: "salesEnquiries" },
		{ component: SalesOrdersPartsIdCreateWorkOrdersAdminComponent, path: "salesOrderParts/:id/createWorkOrders" },
		{ children: [
			{ component: SalesOrdersAdminComponent, path: "" },
			{ component: SalesOrdersIdAdminComponent, path: ":id" },			
			{ component: SalesOrdersIdDeliveryNotesAdminComponent, path: ":id/deliveryNotes" },
			{ component: SalesOrdersIdInvoicesAdminComponent, path: ":id/invoices" },
			{ component: SalesOrdersIdRFQsAdminComponent, path: ":id/rfqs" },
		], path: "salesOrders" },
		{ children: [
			{ component: SitesAdminComponent, path: "" },
			{ component: SitesIdAdminComponent, path: ":id" },
		], path: "sites" },
		{ children: [
			{ component: SkillsAdminComponent, path: "" },
			{ component: SkillsIdAdminComponent, path: ":id" },
		], path: "skills" },
		{ component: SmsAdminComponent, path: "sms" },
		{ children: [
			{ component: SmsTemplateAdminComponent, path: "" },
			{ component: SmsTemplateIdAdminComponent, path: ":id" },
		], path: "sms-templates" },
		{ component: StockControlComponent, path: "webapps/stockControl/:id" },
		{ children: [
			{ component: StoresAdminComponent, path: "" },
			{ component: StoresIdAdminComponent, path: ":id" },
		], path: "stores" },
		{ component: StoreMapAdminComponent, path: "storeMap" },
		{ component: StockStoresHistoryAdminComponent, path: "storesActivity" },
		{ component: StockStoreWorkOrderAllocationsAdminComponent, path: "stockStoreWorkOrderAllocations" },
		{ component: SupervisorComponent, path: "supervisor/:id" },
		{ component: SupervisorRequestsAdminComponent, path: "supervisorRequests" },
		{ children: [
			{ component: SupervisorRequestReasonsAdminComponent, path: "" },
			{ component: SupervisorRequestReasonsIdAdminComponent, path: ":id" },
		], path: "supervisorRequestReasons" },
		{ children: [
			{ component: SupplierAdminComponent, path: "" },
			{ component: SupplierIdAdminComponent, path: ":id" },
		], path: "suppliers" },
		{ children: [
			{ component: SystemParamsAdminComponent, path: "" },
			{ children: [
				{ component: SystemParamIdAdminComponent, path: "" },
				{ component: SystemParamIdValueAdminComponent, path: "values/:vid" },
			], path: ":id" },
		], path: "system-params" },
		{ children: [
			{ component: ToolHoldersAdminComponent, path: "" },
			{ component: ToolHoldersIdAdminComponent, path: ":id" },
		], path: "toolHolders" },
		{ children: [
			{ component: ToolroomProcessesAdminComponent, path: "" },
			{ component: ToolroomProcessesIdAdminComponent, path: ":id" },
		], path: "toolroomProcesses" },
		{ children: [
			{ component: ToolingTypesAdminComponent, path: "" },
			{ component: ToolingTypesIdAdminComponent, path: ":id" },
		], path: "toolingTypes" },
		{ component: UserSettingsAdminComponent, path: "user-settings" },
		{ component: UserHolidaysAdminComponent, path: "userHolidays" },
		{ children: [
			{ component: UserProfilesAdminComponent, path: "" },
			{ component: UserProfilesIdAdminComponent, path: ":id" },
		], path: "users" },
		{ children: [
			{ component: VisitorsAdminComponent, path: "" },
			{ component: VisitorsIdAdminComponent, path: ":id" },
		], path: "visitors" },
		{ children: [
			{ component: WorkOrdersAdminComponent, path: "" },
			{ component: WorkOrdersIdAdminComponent, path: ":id" },
		], path: "workOrders" },
		{ component: WorkOrderScanComponent, path: "woscan" },
		{ component: WorkOrderViewComponent, path: "woview/:id" },
		{ component: PageNotFoundComponent, path: "**" }
	], component: AdminRouteComponent, path: environment.build.adminRoute },
	// Pages for people without a Flow account. Must stay ABOVE the "" branch below, as
	// HomeRouteComponent unconditionally redirects to /admin.
	{ children: [
		{ component: SupplierRequestForQuoteResponsePublicComponent, path: "supplierRFQresponse/:lookupId" },
		{ component: SupplierQuestionnairePublicComponent, path: "supplierquestionaire/:lookupId" },
		{ component: PageNotFoundComponent, path: "**" }
	], component: PublicRouteComponent, path: "public" },
	{ children: [
		{ component: MainComponent, path: "" },
		{ component: ServiceNotAvailableComponent, path: "unavailable" },
		{ component: PageNotFoundComponent, path: "**" }
	], component: HomeRouteComponent, path: "" }
];

export const components = [
	// Components
	AdminHeaderComponent,
	AllocationGridDetailsComponent,
	AndonComponent,
	CadViewerComponent,
	DeliveryNoteLineItemGridDetailsComponent,
	EdiMessageGridDetailsComponent,
	EdiOrderDayQuantitiesComponent,
	EdiSummaryFixingsDetailsComponent,
	InvoiceGridDetailsComponent,
	HeatMapComponent,
	PurchaseGridDetailsComponent,
	SalesEnquiryGridDetailsComponent,
	SalesOrderGridDetailsComponent,
	SkeletonComponent,
	ToolroomLoaderComponent,
	WorkForceWorkOrderStagesDetailsComponent,
	FooterComponent,
	HeaderComponent,
	ModalComponent,
	// Modals
	// Admin
	AccidentAdminComponent,
	AccidentIdAdminComponent,
	AdminRouteComponent,
	AllocationsAdminComponent,
	AllocationsIdAdminComponent,
	AssetsAdminComponent,
	AssetsIdAdminComponent,
	AssetTypesAdminComponent,
	AssetTypesIdAdminComponent,
	AuditAdminComponent,
	AuditIdAdminComponent,
	BankDetailsAdminComponent,
	BankDetailsIdAdminComponent,
	ClientAdminComponent,
	ClientIdAdminComponent,
	CadViewerPageAdminComponent,
	CrmDashboardAdminComponent,
	CrmContactsAdminComponent,
	CrmContactIdAdminComponent,
	CrmEventsAdminComponent,
	CrmEventIdAdminComponent,
	CrmInteractionsAdminComponent,
	CrmInteractionIdAdminComponent,
	CrmLeadsAdminComponent,
	CrmLeadIdAdminComponent,
	CrmOpportunitiesAdminComponent,
	CrmOpportunityIdAdminComponent,
	CrmOpportunityPipelineAdminComponent,
	ClockingAdminComponent,
	CompanyHolidaysAdminComponent,
	CompanyHolidaysIdAdminComponent,
	CompleteAccountIdAdminComponent,
	ContractsAdminComponent,
	ContractsIdAdminComponent,
	CuttingToolsAdminComponent,
	CuttingToolsIdAdminComponent,
	DashboardAdminComponent,
	DeliveryNotesAdminComponent,
	DeliveryNotesDeletedAdminComponent,
	DeliveryNotesIdAdminComponent,
	EdiForecastsAdminComponent,
	EdiMessagesAdminComponent,
	EdiMessagesIdAdminComponent,
	EdiOrdersAdminComponent,
	EdiShippingNotesAdminComponent,
	EdiShippingNotesIdAdminComponent,
	EDIShippingNotesByPartReportAdminComponent,
	EdiSpotOrdersReportAdminComponent,
	EdiSummaryAdminComponent,
	EmployeeMachineTimeAdminComponent,
	EmailsAdminComponent,
	EmailsIdAdminComponent,
	EmailTemplateAdminComponent,
	EmailTemplateIdAdminComponent,
	ExportLogsAdminComponent,
	ExternalPackagingAdminComponent,
	ExternalPackagingIdAdminComponent,
	FeatureAdminComponent,
	FirewallComponent,
	FirewallLogsAdminComponent,
	FirewallLogsIdAdminComponent,
	FirewallLogFailureReasonsAdminComponent,
	FirewallLogFailureReasonsIdAdminComponent,
	FirewallMachineOverviewComponent,
	FloorplanComponent,
	ForgotPasswordAdminComponent,
	GroupsAdminComponent,
	GroupsIdAdminComponent,
	GoodsDetailComponent,
	GoodsMenuComponent,
	HelpAdminComponent,
	HelpIdAdminComponent,
	HolidayAllowancesAdminComponent,
	HolidayAllowancesIdAdminComponent,
	HolidayRequestsAdminComponent,
	HolidayRequestsIdAdminComponent,
	HolidayRequestsPlannerAdminComponent,
	HolidaySettingsAdminComponent,
	InterfaceDevicesAdminComponent,
	InterfaceDevicesIdAdminComponent,
	InvoicesAdminComponent,
	InvoicesArchiveAdminComponent,
	InvoicesDeletedAdminComponent,
	InvoicesIdAdminComponent,
	KnowledgeBaseAdminComponent,
	KnowledgeBaseIdAdminComponent,
	LinkedPartGroupsAdminComponent,
	LinkedPartGroupsIdAdminComponent,
	LogAdminComponent,
	LogIdAdminComponent,
	EmployeeOverviewComponent,
	DepartmentMachineOverviewComponent,
	MachineOverviewComponent,
	SiteOverviewComponent,
	PiSiteOverviewComponent,
	MachinesAdminComponent,
	MachinesIdAdminComponent,
	MachinesIdPFMEAsAdminComponent,
	MachineQuestionnairesAdminComponent,
	MachineRequestsAdminComponent,
	MaintenanceSchedulesAdminComponent,
	MaintenanceSchedulesIdAdminComponent,
	MenuAdminComponent,
	MoveStockComponent,
	NonConformanceReportsAdminComponent,
	NonConformanceReportsIdAdminComponent,
	OperatorComponent,
	ToolroomOverviewComponent,
	OpFloorplanComponent,
	OpsPlanningDepartmentsIdAdminComponent,
	OpsPlanningFirewallAdminComponent,
	OpsPlanningManForManAdminComponent,
	OpsPlanningOutsideProcessContractMovementAdminComponent,
	OpsPlanningSitesIdAdminComponent,
	OpsPlanningWorkforceAdminComponent,
	OrgChartAdminComponent,
	OutsideProcessComponent,
	OutsideProcessContractsAdminComponent,
	OutsideProcessContractsIdAdminComponent,
	OutsideProcessContractsSentButNotReceivedReportAdminComponent,
	OutstandingOrdersAdminComponent,
	PackagingAdminComponent,
	PackagingIdAdminComponent,
	PartsAdminComponent,
	PartsDeletedAdminComponent,
	PartsIdAdminComponent,
	PaymentTermsAdminComponent,
	PaymentTermsIdAdminComponent,
	PFMEASIdAdminComponent,
	ProcessesAdminComponent,
	ProcessesIdAdminComponent,
	ProductionRequestsAdminComponent,
	ProductionToolsAdminComponent,
	ProductionToolsIdAdminComponent,
	SupervisorPerformanceAdminComponent,
	BilletPlannerAdminComponent,
	BlockBoardAdminComponent,
	ToolOrderPlanningAdminComponent,
	ToolOrdersAdminComponent,
	ToolOrdersIdAdminComponent,
	ProductionToolProgramsIdAdminComponent,
	ProductionToolProgramsPrintAdminComponent,
	ProjectAdminComponent,
	ProjectIdAdminComponent,
	PromisesAdminComponent,
	PromisesBoardAdminComponent,
	PromisesIdAdminComponent,
	ProtectedGridsAdminComponent,
	ProtectedGridsIdAdminComponent,
	PurchasableItemsAdminComponent,
	PurchasableItemsIdAdminComponent,
	PurchaseDetailComponent,
	PurchaseLogsAdminComponent,
	PurchaseLogsIdAdminComponent,
	QmsDocumentsAdminComponent,
	QmsDocumentsIdAdminComponent,
	QuarantinedPartsAdminComponent,
	QuotationAnalysisFormsAdminComponent,
	QuotationAnalysisFormsIdAdminComponent,
	RequestForQuotesAdminComponent,
	RequestForQuotesIdAdminComponent,
	ResetPasswordAdminComponent,
	SalesEnquiriesAdminComponent,
	SalesEnquiriesIdAdminComponent,
	SalesEnquiriesFeasibilityAdminComponent,
	SalesOrdersPartsIdCreateWorkOrdersAdminComponent,
	SalesOrdersAdminComponent,
	SalesOrdersIdAdminComponent,
	SalesOrdersIdDeliveryNotesAdminComponent,
	SalesOrdersIdInvoicesAdminComponent,
	SalesOrdersIdRFQsAdminComponent,
	ScheduledReportsAdminComponent,
	ScheduledReportsIdAdminComponent,
	SitesAdminComponent,
	SitesIdAdminComponent,
	SkillsAdminComponent,
	SkillsIdAdminComponent,
	SmsAdminComponent,
	SmsTemplateAdminComponent,
	SmsTemplateIdAdminComponent,
	StoresAdminComponent,
	StoresIdAdminComponent,
	StockControlComponent,
	StoreMapAdminComponent,
	StockStoresHistoryAdminComponent,
	StockStoreWorkOrderAllocationsAdminComponent,
	SupervisorComponent,
	SupervisorRequestsAdminComponent,
	SupervisorRequestReasonsAdminComponent,
	SupervisorRequestReasonsIdAdminComponent,
	SupplierAdminComponent,
	SupplierIdAdminComponent,
	SystemParamsAdminComponent,
	SystemParamIdAdminComponent,
	SystemParamIdValueAdminComponent,
	ToolHoldersAdminComponent,
	ToolHoldersIdAdminComponent,
	ToolroomProcessesAdminComponent,
	ToolroomProcessesIdAdminComponent,
	ToolingTypesAdminComponent,
	ToolingTypesIdAdminComponent,
	UserHolidaysAdminComponent,
	UserProfilesAdminComponent,
	UserProfilesIdAdminComponent,
	UserSettingsAdminComponent,
	VisitorsAdminComponent,
	VisitorsIdAdminComponent,
	WorkOrderScanComponent,
	WorkOrdersAdminComponent,
	WorkOrdersIdAdminComponent,
	WorkOrderViewComponent,
	// Public
	HomeRouteComponent,
	MainComponent,
	PublicRouteComponent,
	SupplierRequestForQuoteResponsePublicComponent,
	SupplierQuestionnairePublicComponent,
	//Other
	PageNotFoundComponent,
	ServiceNotAvailableComponent,
];